import React, { useState, useEffect } from 'react';
import { MatrixQuestion } from '../../survey-tools/likert-scales';
import { shuffleArray } from '../../survey-tools/shuffle-and-sample'; // Import shuffleArray
import { Button } from '@mui/material';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import { Typography} from "@mui/material";
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed


function STAI({ instanceId,nextTask }) {
    const [responses, setResponses] = useState(Array(6).fill(-99)); // Initialize with 6 statements
    const [shuffledStatements, setShuffledStatements] = useState([]);
    const [showDialog, setShowDialog] = useState(false);

    useEffect(() => {
        const statements = [
        "I feel calm",
        "I feel tense",
        "I feel upset",
        "I am relaxed",
        "I feel content",
        "I am worried",
    ];
        setShuffledStatements(shuffleArray(statements));
    }, []); // Empty dependency array to only run once on mount

    const options = ["Not at all", "A little", "Somewhat", "Very much so"];

    const statementKeyMap = {
    "I feel calm": "STAI_1",
    "I feel tense": "STAI_2",
    "I feel upset": "STAI_3",
    "I am relaxed": "STAI_4",
    "I feel content": "STAI_5",
    "I am worried": "STAI_6"

};

    const handleNextClick = () => {
    const isComplete = responses.every(val => val !== -99);
    if (!isComplete) {
        setShowDialog(true);
    } else {
        const staiRatings = {};
        shuffledStatements.forEach((statement, index) => {
            const key = statementKeyMap[statement];
            staiRatings[key] = responses[index];
        });

        nextTask({ data: { stai: staiRatings } });
        console.log(staiRatings);
    }
};


    return (
        <PageContainer>

        <div>
            <MatrixQuestion
                title=<Typography gutterBottom>Read each statement and select the appropriate response to indicate how you feel right now, that is, at this very moment. There are no right or wrong answers. Do not spend too much time on any one statement but give the answer which seems to describe your present feelings best.</Typography>
                rows={shuffledStatements}
                columns={options}
                handleUpdate={(data) => setResponses(data)}
            />
                        <div style={{ height: '20px' }}></div> 

            <Button variant="contained" onClick={handleNextClick}>Next</Button>


            <CustomConfirmationDialog
    open={showDialog}
    onClose={() => setShowDialog(false)}
    onConfirm={() => {
        setShowDialog(false);
        const staiRatings = {};
        shuffledStatements.forEach((statement, index) => {
            const key = statementKeyMap[statement];
            staiRatings[key] = responses[index];
        });

        nextTask({ data: { stai: staiRatings } });
        console.log(staiRatings);
    }}
/>


        </div>
        </PageContainer>

    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(STAI);
